import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useRef } from "react";
import { useScript } from "../../hooks/useScript";
const adultoIdInput = "#adultocz-uid";
export const AdultoAv = ({ scriptLink, scriptKey, onAvFinish }) => {
    const adultoContainerRef = useRef(null);
    useScript({ scriptSrc: scriptLink });
    const observeAdultoId = useCallback((adultoIdInput) => {
        const adultoIdObserver = new MutationObserver(() => {
            const adultoVerificationId = adultoIdInput.value;
            if (adultoVerificationId) {
                onAvFinish(adultoVerificationId);
                adultoIdObserver.disconnect();
            }
        });
        adultoIdObserver.observe(adultoIdInput, { attributes: true });
    }, [onAvFinish]);
    const checkAdultoId = useCallback((adultoIdInput) => {
        const adultoVerificationId = adultoIdInput.value;
        if (adultoVerificationId) {
            onAvFinish(adultoVerificationId);
            return;
        }
        observeAdultoId(adultoIdInput);
    }, [onAvFinish, observeAdultoId]);
    useEffect(() => {
        const adultoContainerObserver = new MutationObserver(() => {
            const avVerificationIdInput = adultoContainerRef.current?.querySelector(adultoIdInput);
            if (avVerificationIdInput) {
                checkAdultoId(avVerificationIdInput);
                adultoContainerObserver.disconnect();
            }
        });
        adultoContainerObserver.observe(adultoContainerRef.current, { childList: true });
        return () => {
            adultoContainerObserver.disconnect();
        };
    }, [checkAdultoId]);
    return _jsx("div", { className: "adulto-cz", "data-testid": "adultoContainer", "data-sitekey": scriptKey, ref: adultoContainerRef });
};
//# sourceMappingURL=AdultoAv.js.map